// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__2emvU","checkboxCol":"Table_checkboxCol__9uC57","emailCol":"Table_emailCol__mKnR_","actionCol":"Table_actionCol__yK2Wf"};